import React from "react"

import {FieldTableCellProps, getTableCellStyle} from "../../../../render/table/table-cell"
import WorkItemIcon from "./work-item-icon"

export default function FieldTimeReportEntity_TableCell(props: FieldTableCellProps): React.ReactElement {
    const timeReport = props.listItem.timeReport
    const title = timeReport.title

    return (
        <div className  = "cell-flex"
             style      = {getTableCellStyle(props)}
        >
            <div className="flex-row-left-center txt-truncate p-l-8">
                <WorkItemIcon timeReport={timeReport}/>
                <span className="ui5-txt-less-important-small txt-truncate">{title}</span>
            </div>
        </div>
    )
}
